package org.mkui.component

import com.macrofocus.common.timing.Timing
import org.mkui.canvas.*
import org.mkui.canvas.MouseEvent
import org.mkui.keyCode
import org.w3c.dom.Element
import web.events.addEventHandler
import web.events.removeEventListener
import web.html.HTMLElement
import web.keyboard.KEY_DOWN
import web.mouse.*
import web.pointer.CONTEXT_MENU

class CPInteractiveHandler(private val canvas: HTMLElement, private val listeners: InteractiveComponentListeners = InteractiveComponentListeners(), private val interactTiming: Timing? = null) {
    private var keyListenerRegistered = false
    private var mouseEntered = false
    private var dragging = false
    //    private val mouseMove: HandlerRegistration? = null
    var onmousemove: ((web.mouse.MouseEvent) -> dynamic)? = null
    val onmousedrag: ((web.mouse.MouseEvent) -> dynamic) = {
        for (mouseMotionListener in listeners.mouseMotionListeners) {
            if(mouseMotionListener != null) {
                mouseMotionListener.mouseDragged(JSMouseEvent(it, 0))
            }
        }
        it.stopPropagation()
    }

    init {
        registerMouseListener()
        registerMouseMotionListener()
        registerMouseWheelListener()
        registerKeyListener()
        registerContextMenuListener()
    }

    fun registerMouseListener() {
        if (canvas != null) {
            canvas.addEventHandler(web.mouse.MouseEvent.MOUSE_UP) {
                for (l in listeners.mouseListeners) {
                    if(l != null) {
                        l.mouseClicked(JSMouseEvent(it, 0))
                        if (dragging) {
                            stopDragging()
                        }
                        l.mouseReleased(JSMouseEvent(it, 0))
                    }
                }
            }
            canvas.addEventHandler(web.mouse.MouseEvent.MOUSE_DOWN) {
                if (!dragging) {
                    startDragging()
                }
                for (l in listeners.mouseListeners) {
                    if(l != null) {
                        l.mousePressed(JSMouseEvent(it, 1))
                    }
                }
            }
            canvas.addEventHandler(web.mouse.MouseEvent.MOUSE_OVER) {
                if (!mouseEntered) {
                    mouseEntered = true
//                    if (keyListenerRegistered) {
//                            Scheduler.get().scheduleDeferred(object : ScheduledCommand() {
//                                fun execute() {
//                                    if (nativeComponent is FocusWidget) {
//                                        (nativeComponent as FocusWidget).setFocus(true)
//                                    }
//                                }
//                            })
//                    }
                    if (!dragging) {
                        for (l in listeners.mouseListeners) {
                            if(l != null) {
                                l.mouseEntered(JSMouseEvent(it, 0))
                            }
                        }
                    }
                }
            }
        }
        canvas.addEventHandler(web.mouse.MouseEvent.MOUSE_OUT) {
            mouseEntered = false
            //                stopDragging();
            if (!dragging) {
                for (l in listeners.mouseListeners) {
                    if(l != null) {
                        l.mouseExited(JSMouseEvent(it, 0))
                    }
                }
            }
        }
        canvas.addEventHandler(web.mouse.MouseEvent.DBL_CLICK) {
            for (l in listeners.mouseListeners) {
                if(l != null) {
                    l.mousePressed(JSMouseEvent(it, 2))
                }
            }
        }
    }

    fun registerMouseMotionListener() {
        if (canvas != null) {
            onmousemove = {
                interactTiming?.start()
                if (!dragging) {
                    for (l in listeners.mouseMotionListeners) {
                        if(l != null) {
                            l.mouseMoved(JSMouseEvent(it, 0))
                        }
                    }
                }
                interactTiming?.stop()
            }
            canvas.addEventHandler(web.mouse.MouseEvent.MOUSE_MOVE, onmousemove!!)
//            canvas.ontouchmove =  {
//            }
        }
    }

    fun registerMouseWheelListener() {
        if (canvas != null) {
            canvas.addEventHandler(web.mouse.WheelEvent.WHEEL) {
                it.preventDefault()
                for (l in listeners.mouseWheelListeners) {
                    if(l != null) {
                        l.mouseWheelMoved(object : MouseWheelEvent {
                            override val x: Int
                                get() = it.x.toInt()
                            override val y: Int
                                get() = it.y.toInt()
                            override val wheelRotation: Double
                                get() = it.deltaY
                        })
                    }
                }
            }
        }
    }

    fun startDragging() {
        dragging = true
        if (canvas != null) {
//            com.google.gwt.user.client.Event.setCapture(canvas.getElement());
            canvas.removeEventListener(web.mouse.MouseEvent.MOUSE_MOVE, onmousemove!!)
            canvas.addEventHandler(web.mouse.MouseEvent.MOUSE_MOVE, onmousedrag)
        }
    }

    fun stopDragging() {
        if (dragging) {
//            com.google.gwt.user.client.Event.releaseCapture(nativeComponent.getCanvas().getElement());
            dragging = false
            canvas.removeEventListener(web.mouse.MouseEvent.MOUSE_MOVE, onmousedrag!!)
            canvas.addEventHandler(web.mouse.MouseEvent.MOUSE_MOVE, onmousemove!!)
        }
    }

    fun registerKeyListener() {
        keyListenerRegistered = true
//        nativeComponent.sinkEvents(com.google.gwt.user.client.Event.KEYEVENTS)
        canvas.addEventHandler(web.keyboard.KeyboardEvent.KEY_DOWN) {
            val code = -1
//            when (it.keyCode) {
//                KeyCodes.KEY_DOWN -> code = VK_DOWN
//                KeyCodes.KEY_UP -> code = VK_UP
//                KeyCodes.KEY_PAGEDOWN -> code = VK_PAGE_DOWN
//                KeyCodes.KEY_PAGEUP -> code = VK_PAGE_UP
//                else -> code = it.keyCode
//            }
            if (code >= 0) {
                for (l in listeners.keyListeners) {
                    if(l != null) {
                        l.keyPressed(ElementalKeyEvent(it.keyCode))
                    }
                }
            }
        }

//                    final String key = event.getNativeEvent().getKeyCode()key;
//                    if(key != null) {
//                        int code = -1;
//                        switch (key) {
//                            case "ArrowDown":
//                                code = VK_DOWN;
//                                break;
//                            case "ArrowUp":
//                                code = VK_UP;
//                                break;
//                            case "PageDown":
//                                code = VK_PAGE_DOWN;
//                                break;
//                            case "PageUp":
//                                code = VK_PAGE_DOWN;
//                                break;
//                        }
//
//                        if(code >= 0) {
//                            l.keyPressed(new ElementalKeyEvent(code));
//                        }
//            }
//        }, KeyDownEvent.getType());
//        if(canvas != null) {
//            canvas.onkeydown = new elemental2.dom.Element.OnkeydownFn() {
//                @Override
//                public Object onInvoke(Event event) {
//                    GWTConsole.log("Receiving " + event);
//                    final String key = ((KeyboardEvent) event).key;
//                    if(key != null) {
//                        int code = -1;
//                        switch (key) {
//                            case "ArrowDown":
//                                code = VK_DOWN;
//                                break;
//                            case "ArrowUp":
//                                code = VK_UP;
//                                break;
//                            case "PageDown":
//                                code = VK_PAGE_DOWN;
//                                break;
//                            case "PageUp":
//                                code = VK_PAGE_DOWN;
//                                break;
//                        }
//
//                        if(code >= 0) {
//                            l.keyPressed(new ElementalKeyEvent(code));
//                        }
//                    }
//                    return null;
//                }
//            };
//
//            canvas.onkeyup = new elemental2.dom.Element.OnkeyupFn() {
//                @Override
//                public Object onInvoke(Event event) {
//                    GWTConsole.log("Receivingx " + event);
//                    l.keyReleased(new ElementalKeyEvent(-1));
//                    return null;
//                }
//            };
//        }
    }

    fun registerContextMenuListener() {
//        if (nativeComponent != null) {
//            nativeComponent.sinkEvents(com.google.gwt.user.client.Event.ONCONTEXTMENU)
        canvas.addEventHandler(web.pointer.PointerEvent.CONTEXT_MENU) {
                it.preventDefault()
                it.stopPropagation()
                for (l in listeners.contextMenuListeners) {
                    if(l != null) {
                        l.contextMenu(object : ContextMenuEvent {
                            override val x: Int
                                get() = it.clientX
                            override val y: Int
                                get() = it.clientY
                        })
                    }
                }
            }
//        }
    }

    class ElementalMouseEvent(event: org.w3c.dom.events.MouseEvent, override val clickCount: Int) : MouseEvent {
        private val event: org.w3c.dom.events.MouseEvent

        // Possbily an alternative way to compute it irrespectively of the scale/transform
//                return (int) (event.clientX - currentTarget.clientX);
        override val x: Int
            get() = if (event.currentTarget != null && event.currentTarget !== event.target) {
                val currentTarget: org.w3c.dom.HTMLElement = event.currentTarget!! as org.w3c.dom.HTMLElement
                val target: Element = event.target!! as Element
                val scaleX: Double = currentTarget.getBoundingClientRect().width / currentTarget.offsetWidth
                ((target.getBoundingClientRect().left - currentTarget.getBoundingClientRect().left) / scaleX + event.offsetX)
                scaleX.toInt()
                // Possibly an alternative way to compute it irrespectively of the scale/transform
                //                return (int) (event.clientX - currentTarget.clientX);
            } else {
                event.offsetX.toInt()
            }

        // Possibly an alternative way to compute it irrespectively of the scale/transform
//                return (int) (event.clientY - currentTarget.clientY);
        override val y: Int
            get() {
                return if (event.currentTarget != null && event.currentTarget !== event.target) {
                    val currentTarget: org.w3c.dom.HTMLElement = event.currentTarget!! as org.w3c.dom.HTMLElement
                    val target: Element = event.target!! as Element
                    val scaleY: Double = currentTarget.getBoundingClientRect().height / currentTarget.offsetHeight
                    ((target.getBoundingClientRect().top - currentTarget.getBoundingClientRect().top) / scaleY + event.offsetY)
                    // Possbily an alternative way to compute it irrespectively of the scale/transform
                    //                return (int) (event.clientY - currentTarget.clientY);
                    scaleY.toInt()
                } else {
                    event.offsetY.toInt()
                }
            }

        override val isMenuShortcutKeyDown: Boolean
            get() {
                return event.ctrlKey || event.metaKey
            }
        override val isAltKeyDown: Boolean
            get() = event.altKey
        override val isShiftKeyDown: Boolean
            get() = event.shiftKey
        override val isMultipleSelectionKey: Boolean
            get() {
                return event.ctrlKey || event.metaKey
            }
        override val isPopupTrigger: Boolean
            get() = false
        override val isLeftMouseButton: Boolean
            get() = event.button == 0.toShort()
        override val isMiddleMouseButton: Boolean
            get() = event.button == 1.toShort()

        override fun stopPropagation() {
            event.stopPropagation()
        }

        init {
            this.event = event
        }
    }

    class ElementalKeyEvent(override val keyCode: Int) :
        KeyEvent //    public static class ElementalTouchEvent implements MouseEvent {

    //        private final elemental2.dom.TouchEvent event;
    //        private final int clickCount;
    //
    //        public ElementalTouchEvent(elemental2.dom.TouchEvent event, int clickCount) {
    //            this.event = event;
    //            this.clickCount = clickCount;
    //        }
    //
    //        @Override
    //        public int getX() {
    ////            Element relativeElem = event.getRelativeElement();
    ////            if (relativeElem != null) {
    ////                return getRelativeX(relativeElem);
    ////            }
    //            return event.getNativeEvent().getClientX();
    //        }
    //
    //        @Override
    //        public int getY() {
    //            Element relativeElem = event.getRelativeElement();
    //            if (relativeElem != null) {
    //                return getRelativeY(relativeElem);
    //            }
    //            return event.getNativeEvent().getClientY();
    //        }
    //
    //        public int getRelativeX(Element target) {
    //            NativeEvent e = event.getNativeEvent();
    //
    //            return e.getClientX() - target.getAbsoluteLeft() + target.getScrollLeft() +
    //                    target.getOwnerDocument().getScrollLeft();
    //        }
    //
    //        public int getRelativeY(Element target) {
    //            NativeEvent e = event.getNativeEvent();
    //
    //            return e.getClientY() - target.getAbsoluteTop() + target.getScrollTop() +
    //                    target.getOwnerDocument().getScrollTop();
    //        }
    //
    //        @Override
    //        public boolean isMenuShortcutKeyDown() {
    //            boolean ctrlOrMeta = event.getNativeEvent().getCtrlKey() || event.getNativeEvent().getMetaKey();
    //            return ctrlOrMeta;
    //        }
    //
    //        @Override
    //        public boolean isAltKeyDown() {
    //            return event.getNativeEvent().getAltKey();
    //        }
    //
    //        @Override
    //        public boolean isShiftKeyDown() {
    //            return event.getNativeEvent().getShiftKey();
    //        }
    //
    //        @Override
    //        public boolean isMultipleSelectionKey() {
    //            boolean ctrlOrMeta = event.getNativeEvent().getCtrlKey() || event.getNativeEvent().getMetaKey();
    //            return ctrlOrMeta;
    //        }
    //
    //        @Override
    //        public boolean isPopupTrigger() {
    //            return false;
    //        }
    //
    //        @Override
    //        public boolean isLeftMouseButton() {
    //            return event.getNativeEvent().getButton() == NativeEvent.BUTTON_LEFT;
    //        }
    //
    //        @Override
    //        public boolean isMiddleMouseButton() {
    //            return event.getNativeEvent().getButton() == NativeEvent.BUTTON_MIDDLE;
    //        }
    //
    //        @Override
    //        public void stopPropagation() {
    //            event.stopPropagation();
    //        }
    //
    //        @Override
    //        public int getClickCount() {
    //            return clickCount;
    //        }
    //    }
}